import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum ArkFoodsBillOfLadingSalesOrderLineItemKeys {
  numberOfUnits = 'numberOfUnits',
  productDescription = 'productDescription',
  descriptionOfArticles = 'descriptionOfArticles',
}

export const arkFoodsBillOfLadingSalesOrderLineItemSchema = yup.object({
  [ArkFoodsBillOfLadingSalesOrderLineItemKeys.numberOfUnits]: yup.string().notRequired(),
  [ArkFoodsBillOfLadingSalesOrderLineItemKeys.productDescription]: yup.string().notRequired(),
  [ArkFoodsBillOfLadingSalesOrderLineItemKeys.descriptionOfArticles]: yup.string().notRequired(),
})

export const arkFoodsAddressLineSchema = yup.object({
  line: yup.string().notRequired(),
})

export const arkFoodsBillOfLadingFileDataSchema = yup.object({
  orderType: yup.string().notRequired(),
  customer: yup.string().notRequired(),
  requiredTruckTemp: yup.string().notRequired(),
  trailerCarNo: yup.string().notRequired(),
  estShipDate: yup.string().notRequired(),
  estDelDate: yup.string().notRequired(),
  estNumberOfPallets: yup.string().notRequired(),
  poNumber: yup.string().notRequired(),
  truckTemp: yup.string().notRequired(),
  pickupNumber: yup.string().notRequired(),
  appointment: yup.string().notRequired(),
  to: yup.array().of(arkFoodsAddressLineSchema).required(),
  from: yup.array().of(arkFoodsAddressLineSchema).required(),
  shippersInstructions: yup.string().notRequired(),
  freightBill: yup.string().notRequired(),
  salesOrderLineItems: yup.array().of(arkFoodsBillOfLadingSalesOrderLineItemSchema).required(),
  productTempUponLoading: yup.string().notRequired(),
  tempRecorder: yup.string().notRequired(),
  seal: yup.string().notRequired(),
  truckInspection: yup.string().notRequired(),
  shipTime: yup.string().notRequired(),
  shipperSignature: yup.string().notRequired(),
  shipperSignatureDate: yup.string().notRequired(),
  truckerSignature: yup.string().notRequired(),
  truckerSignatureDate: yup.string().notRequired(),
  receiverSignature: yup.string().notRequired(),
  receiverSignatureDate: yup.string().notRequired(),
  notesStrings: yup.string().notRequired(),
})

export type ArkFoodsBillOfLadingFileData = yup.InferType<typeof arkFoodsBillOfLadingFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<ArkFoodsBillOfLadingFileData>

export const arkFoodsBillOfLadingFileMappings: RequiredFileData = {
  orderType: 'ce80f24c-0d64-4b8d-8a15-8c2e6570c228',
  customer: 'c7395655-67e7-4d43-995d-16c52e8fc1ab',
  requiredTruckTemp: '7f6180bf-5927-4479-87ea-78cb9fc06ad2',
  trailerCarNo: 'f3b9ba72-0001-42f4-a2f5-c79b0e5f1a86',
  estShipDate: 'e6a5f9dc-a2b3-4328-9381-62835550ed9d',
  estDelDate: 'b1ff8fbd-80d2-459c-bfd9-d7dc1463a267',
  estNumberOfPallets: 'a2b886f3-15bf-47a2-a5f2-3f598aa3f2eb',
  poNumber: 'a84c4230-8473-4963-a264-fd9ddd57be14',
  truckTemp: '4e6fb596-61d8-445e-b94d-19871497d6c9',
  pickupNumber: 'b8e2a1c4-3d5f-4a6b-9c7e-8f0d1e2a3b4c',
  appointment: 'c9f3b2d5-4e6a-4b7c-8d0e-9f1a2b3c4d5e',
  to: [{ line: 'fda0ec3c-b520-4a0c-bfce-55f7d32c0e59' }],
  from: [{ line: '401836dc-9974-4b7c-9fd0-43c548d411fd' }],
  shippersInstructions: '70fe6eb4-19a0-42a1-bd69-9aeb9ba80f57',
  freightBill: '2a132c8f-e2ec-499c-bb70-a067d7d10bbd',
  salesOrderLineItems: [
    {
      numberOfUnits: 'ded29aba-f910-4d16-b6a5-f64de12dfdaa',
      productDescription: '21a90a85-fd0d-4790-8eca-277231bd0483',
      descriptionOfArticles: '3c736ff9-af7a-4eb4-bb83-ee24027953ff',
    },
  ],
  productTempUponLoading: '0ec5ad67-a46f-4158-90f4-25dc0600468f',
  tempRecorder: 'b3c99a6c-ffd2-42a2-a837-629a05c75ae4',
  seal: '01d1e6ed-4c01-4521-b5a3-2740747b9796',
  truckInspection: '371c68f1-26ca-4989-bd0e-073c9a998ff3',
  shipTime: 'f4ad143f-8ac9-472d-a7c3-72def23cae5b',
  shipperSignature: 'cdf766a5-f866-49b3-ab54-57e22011ff2e',
  shipperSignatureDate: '1178b034-ec7c-4769-a441-5e95803b2be4',
  truckerSignature: '3532a2fd-a93b-4e97-974b-9aebba6f93a5',
  truckerSignatureDate: '1ef9c6f2-6c9a-422c-9ffd-f0c3d0e4f740',
  receiverSignature: '21c3015f-6979-457d-958a-1b852e0c2748',
  receiverSignatureDate: 'd14eb031-d2e4-430d-b320-4a48de89457b',
  notesStrings: '1f0d9e47-971a-4d6c-8d3a-249a921f27ee',
}
